module.exports = __webpack_public_path__ + "static/media/close_button_icon.db03d729.svg";